
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Typography from '@material-ui/core/Typography'
import StyleSheet from 'styles'
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { ConditionalRender } from 'components'
import { Authorization } from 'utils'
export class Summary extends Component{

  static propTypes = {
    totals: PropTypes.object.isRequired
  }

  monetize = (value, currency) => {
    return (value && value !== '0.0') ? `${value}${currency}` : ''
  }

  getCommissionText = (partyType, status) => {
    return [
      this.monetize(this.props.totals[`${partyType}CoinCommission${status}`], this.props.currencyCode),
      this.monetize(this.props.totals[`${partyType}TokenCommission${status}`], this.props.ticker)
    ].filter(c => c).join(' + ')
  }

  render = () =>
    <div className={styles.allocationSummary}>
      <Typography variant='subtitle1' className={styles.summarySubheading}>{this.props.title}</Typography>
      <div className={styles.summaryTables}>
        <Table className={styles.summaryTable}>
          <TableBody>
            <TableRow>
              <TableCell>Amount Allocated</TableCell>
              <TableCell>{this.props.totals.amountAllocated}{this.props.ticker}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Amount Claimed</TableCell>
              <TableCell>{this.props.totals.amountClaimed}{this.props.ticker}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Payment Expected</TableCell>
              <TableCell>{this.props.totals.paymentExpected}{this.props.currencyCode}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Payment Received</TableCell>
              <TableCell>{this.props.totals.paymentReceived}{this.props.currencyCode}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
        <ConditionalRender component={Table} requires={Authorization.admin}  className={styles.summaryTable}>
          <TableBody>
            <TableRow>
              <TableCell>Commission Expected</TableCell>
              <TableCell>{this.getCommissionText('organisation', 'Expected')}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Commission Received</TableCell>
              <TableCell>{this.getCommissionText('organisation', 'Received')}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Third Party Commission Expected</TableCell>
              <TableCell>{this.getCommissionText('thirdParty', 'Expected')}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Third Party Commission Received</TableCell>
              <TableCell>{this.getCommissionText('thirdParty', 'Received')}</TableCell>
            </TableRow>
          </TableBody>
        </ConditionalRender>
      </div>
    </div>

}


const styles = StyleSheet({
  allocationSummary: {
    marginTop: 20
  },
  summarySubheading: {
    flexGrow: 1,
    flexShrink: 0,
    textAlign: 'left',
    margin: 10
  },
  summaryTables: {
    marginTop: 10,
    fontSize: 11,
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap'
  },
  summaryTable: {
    flex: 1,
    border: '1px solid rgba(255, 255, 255, 0.1)',
    width: '50%',
    '& tr > td:nth-child(1)': {
      background: 'rgba(255, 255, 255, 0.1)'
    },
    '@media(max-width: 800px)': {
      tableLayout: 'fixed',
      minWidth: '100%',
      '& tr > td': {
        padding: '0 10px',
        fontSize: 12
      },
      '& tr > td:nth-child(1)': {
        width: 200
      }
    }
  }
})
